import client from "./client";

const reviewsApi = {
  listPublic() {
    return client.get("/reviews/public").then((r) => r.data);
  },
  list() {
    return client.get("/reviews").then((r) => r.data);
  },
  create(body) {
    return client.post("/reviews", body).then((r) => r.data);
  },
  remove(id) {
    return client.delete(`/reviews/${id}`).then((r) => r.data);
  },
};

export default reviewsApi;
